<!--
 * @Descripttion: 
 * @version: v1
 * @Author: liukx
 * @Date: 2022-05-01 23:09:12
 * @LastEditors: ???
 * @LastEditTime: 2022-06-08 15:18:13
-->
<template>
  <div class="wrapper">
    <el-dialog
      :close-on-click-modal="visible"
      :title="title"
      :visible.sync="visible"
      width="50%"
      @close="close"
    >
      <el-form
        :model="form"
        ref="form"
        :rules="validatorRules"
        label-width="120px"
        :inline="false"
        size="normal"
        :disabled="formDisabled"
      >
        <el-form-item label="回收员" prop="wlUserId">
          <el-select
            v-model="form.wlUserId"
            clearable
            filterable
            remote
            :remote-method="recyclerRemoteMethod"
            :loading="recyclerLoading"
          >
            <el-option
              v-for="item in recyclerOpts"
              :key="item.wlUserId"
              :label="item.name"
              :value="item.wlUserId"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="开始时间" prop="startTime">
          <el-date-picker
            v-model="form.startTime"
            type="datetime"
            placeholder="选择日期时间"
            default-time="00:00:00"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime">
          <el-date-picker
            v-model="form.endTime"
            type="datetime"
            placeholder="选择日期时间"
            default-time="00:00:00"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-radio-group v-model="form.type">
            <el-radio :label="1">限制约单时间</el-radio>
            <el-radio :label="2">限最大制约单量</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="最大约单量" v-if="form.type == 2">
          <el-input
            v-model.trim="form.maxOrderCount"
            placeholder="请输入最大约单量"
            maxlength="50"
            style="width: 90%"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" v-if="!formDisabled">
        <el-button @click="visible = false" size="mini">取消</el-button>
        <el-button type="primary" @click="handleOk" size="mini">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { httpAction } from "@/api/manage";
import { getRecyclertList } from "@/api/sign"

import { listMixin } from "@/mixins/listMixin";
import { convertTime } from "@/utils/util";

export default {
  components: {},
  mixins: [listMixin],
  props: {},
  data() {
    return {
      formDisabled: false,
      disableMixinCreated: true,
      title: "操作",
      visible: false,
      confirmLoading: false,
      form: { startTime: '', endTime: ''},
      validatorRules: {
        wlUserId: [
          { required: true, message: "请输入回收员", trigger: "change" },
        ],
        startTime: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        endTime: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
      },
      url: {
        add: "/wlRecyclerEvent/add",
        edit: "/wlRecyclerEvent/edit",
        detail: "/wlRecyclerEvent/detail",
      },
      recyclerOpts: [],
      recyclerLoading: false,
    };
  },
  watch: {},
  computed: {},
  methods: {
    recyclerRemoteMethod (name) {
      if (name !== "") {
        this.recyclerLoading = true
        getRecyclertList({ name, pageNo: 1, pageSize: 999 }).then((res) => {
          this.recyclerOpts = res.data.records
          this.recyclerLoading = false
        })
      } else {
        this.recyclerOpts = []
        this.recyclerLoading = false
      }
    },
    add() {
      this.edit();
    },
    edit(record, type) {
      this.formDisabled = type;
      record &&
        httpAction(this.url.detail + '?id=' + record.id, {}, "post").then((res) => {
          if (res.code === 200) {
            res.data.startTime = res.data.startTime ? new Date(res.data.startTime) : null;
            res.data.endTime = res.data.endTime ? new Date(res.data.endTime) : null;
            // res.data.maxOrderCount = res.data.maxOrderCount + '';
            this.form = res.data;
            this.recyclerRemoteMethod(res.data.userName)
          }
        });
      this.visible = true;
    },
    close() {
      this.$refs.form.resetFields();
      this.$emit("close");
      this.form = {}
      this.recyclerOpts = []
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.$refs.form.validate((valid) => {
        if (valid) {
      console.log(this.form);
      if (this.form.type == 2 && !this.form.maxOrderCount) return this.$message.warning("请填写最大约单量");
          const timeReg = /^(\d{4})/;
          let startTime = ''
          let endTime = ''
          if (this.form.startTime ? !timeReg.test(this.form.startTime) : "")
            startTime = convertTime(this.form.startTime);
          if (this.form.endTime ? !timeReg.test(this.form.endTime) : "")
            endTime = convertTime(this.form.endTime);
          that.confirmLoading = true;
          let httpurl = "";
          let method = "";
          const parms = { ...this.form, startTime, endTime};
          if (!this.form.id) {
            httpurl += this.url.add;
            method = "post";
          } else {
            httpurl += this.url.edit;
            method = "post"; //put
            parms.userId = this.form.id;
          }
          httpAction(httpurl, parms, method)
            .then((res) => {
              if (res.code == 200) {
                that.$message.success("操作成功");
                that.$emit("ok");
              } else {
                that.$message.warning(res.msg);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.wrapper {
}
.formDiv {
  margin-left: 40px;
  margin-bottom: 22px;
  span {
    width: 80px;
    line-height: 36px;
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    font-weight: 700;
    color: #606266;
    padding: 0 12px 0 0;
    box-sizing: border-box;
    cursor: default;
  }
}
.hide /deep/ .el-upload--picture-card {
  display: none;
}
.show /deep/ .el-upload--picture-card {
  display: block;
}
</style>
